import { Box, BoxProps } from '@chakra-ui/react'

export function LogoutIcon({ ...props }: BoxProps) {
    return (
        <Box {...props}>
            <svg width="24" height="24" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.1376 19.3833C16.0607 21.3204 14.4464 22.9652 12.2839 22.9123C11.7808 22.9 11.1589 22.7246 9.91526 22.3738C6.9222 21.5295 4.32393 20.1107 3.70053 16.9321C3.58594 16.3479 3.58594 15.6904 3.58594 14.3755L3.58594 12.624C3.58594 11.309 3.58594 10.6516 3.70053 10.0673C4.32393 6.88879 6.9222 5.46993 9.91527 4.62569C11.1589 4.27489 11.7808 4.09949 12.2839 4.08718C14.4464 4.03428 16.0607 5.67903 16.1376 7.61611" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                <path d="M22.4139 13.4997H10.9082M22.4139 13.4997C22.4139 12.7673 20.3279 11.3989 19.799 10.8848M22.4139 13.4997C22.4139 14.2321 20.3279 15.6005 19.799 16.1146" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <defs>
                    <linearGradient id="paint0_linear_403_12251" x1="3.58594" y1="5.02731" x2="18.4628" y2="7.2333" gradientUnits="userSpaceOnUse">
                        <stop stop-color="currentColor" />
                        <stop offset="1" stop-color="currentColor" />
                    </linearGradient>
                    <linearGradient id="paint1_linear_403_12251" x1="10.9082" y1="11.1463" x2="22.1527" y2="16.6486" gradientUnits="userSpaceOnUse">
                        <stop stop-color="currentColor" />
                        <stop offset="1" stop-color="currentColor" />
                    </linearGradient>
                </defs>
            </svg>
        </Box>
    )
}
